import React from 'react';
import { Container, CardGroup, Card, CardBody, CardImage, CardTitle, CardText, Fa } from 'mdbreact';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import thumb_cadence_library from 'assets/architecture/thumb_cadence_library.jpg';
import thumb_desmosome from 'assets/architecture/thumb_desmosome.jpg';
import thumb_ice_dice from 'assets/architecture/thumb_ice_dice.jpg';

import pdf_cadence_library from 'assets/architecture/pdf_cadence_library.pdf';
import pdf_desmosome from 'assets/architecture/pdf_desmosome.pdf';
import pdf_ice_dice from 'assets/architecture/pdf_ice_dice.pdf';


import thumb_residence from 'assets/architecture/thumb_residence.jpg';
import thumb_urban_retreat from 'assets/architecture/thumb_urban_retreat.jpg';
import thumb_playground from 'assets/architecture/thumb_playground.jpg';

import pdf_residence from 'assets/architecture/pdf_residence.pdf';
import pdf_urban_retreat from 'assets/architecture/pdf_urban_retreat.pdf';
import pdf_playground from 'assets/architecture/pdf_playground.pdf';


class PageArchitecture extends React.Component {
  static get propTypes() {
    return {
      propTitle: PropTypes.string,
      onActivated: PropTypes.func
    };
  }

  componentDidMount() {
    console.log(`PageArchitecture::componentDidMount with props: ${this.props}`);
    console.log(this.props);
    this.props.onActivated(this.props.propTitle);
  }

  render() {
    console.log('PageArchitecture::render');
    return (
      <Container className="mt-5">
        <CardGroup deck>

          <Card>
            <CardImage src={thumb_cadence_library} alt="Cadence Library" top hover overlay="white-slight"/>
            <CardBody>
              <CardTitle tag="h5">Cadence Library</CardTitle>
              <CardText>Located at three streets intersection, library emphasizes entrance as a critical part of design.</CardText>
              <a href={pdf_cadence_library} target="_blank" className="black-text d-flex justify-content-end">
                <h5>Read more <Fa icon="angle-double-right" /></h5>
              </a>
            </CardBody>
          </Card>

          <Card>
            <CardImage src={thumb_desmosome} alt="Desmosome" top hover overlay="white-slight"/>
            <CardBody>
              <CardTitle tag="h5">Desmosome</CardTitle>
              <CardText>Desmosome is placed in a residential area as a gathering place and shelter.</CardText>
              <a href={pdf_desmosome} target="_blank" className="black-text d-flex justify-content-end">
                <h5>Read more <Fa icon="angle-double-right" /></h5>
              </a>
            </CardBody>
          </Card>

          <Card>
            <CardImage src={thumb_ice_dice} alt="Ice Dice" top hover overlay="white-slight"/>
            <CardBody>
              <CardTitle tag="h5">Ice Dice</CardTitle>
              <CardText>Ice Dice is a research station located by Cunningham River on Somerset Island, Canada.</CardText>
              <a href={pdf_ice_dice} target="_blank" className="black-text d-flex justify-content-end">
                <h5>Read more <Fa icon="angle-double-right" /></h5>
              </a>
            </CardBody>
          </Card>

        </CardGroup>

        <br/>

        {/* 2d row */} {/* eslint-disable-line no-inline-comments */}
        <CardGroup deck>
          <Card>
            <CardImage src={thumb_residence} alt="Residence" top hover overlay="white-slight"/>
            <CardBody>
              <CardTitle tag="h5">Residence</CardTitle>
              <CardText>The aim of this project is to house five students and allow for an attached public space.</CardText>
              <a href={pdf_residence} target="_blank" className="black-text d-flex justify-content-end">
                <h5>Read more <Fa icon="angle-double-right" /></h5>
              </a>
            </CardBody>
          </Card>

          <Card>
            <CardImage src={thumb_urban_retreat} alt="Urban retreat" top hover overlay="white-slight"/>
            <CardBody>
              <CardTitle tag="h5">Urban retreat</CardTitle>
              <CardText>This 4x8x8m concrete shell is a retreat for one or two people from the bustling city life.</CardText>
              <a href={pdf_urban_retreat} target="_blank" className="black-text d-flex justify-content-end">
                <h5>Read more <Fa icon="angle-double-right" /></h5>
              </a>
            </CardBody>
          </Card>

          <Card>
            <CardImage src={thumb_playground} alt="Interactive playground" top hover overlay="white-slight"/>
            <CardBody>
              <CardTitle tag="h5">Interactive playground</CardTitle>
              <CardText>This playground is colourful, interactive, and holds many mysteries for kids of all ages.</CardText>
              <a href={pdf_playground} target="_blank" className="black-text d-flex justify-content-end">
                <h5>Read more <Fa icon="angle-double-right" /></h5>
              </a>
            </CardBody>
          </Card>
        </CardGroup>

      </Container>

    );
  }
}

export default withRouter(PageArchitecture);




// WEBPACK FOOTER //
// ./src/Pages/Architecture/page-architecture.js